import {
    ReactElement,
    ButtonHTMLAttributes
} from "react";
import {  Arrowleft } from "../../assets";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
    image?: any;
    myStyle?: string;
    countTitle: string;
    countValue: string;
    headLineTitle: string;
    badge?: string;
    isExpired?: boolean;
    showArrow?:boolean;
}

export function TotalCardMini({ image, myStyle, isExpired, countTitle, countValue, headLineTitle , showArrow }: Props): ReactElement {

    return (
        <div className={`total-card-mini ${myStyle && myStyle} ${isExpired ? "total-card-mini-expired" : ""}`}>
            <div className="head-line">
                <div className="icon-container">
                    {image}
                </div>
                <span className="title"> {headLineTitle}  </span>
            </div>
            <div className="count">
                <span className="value">
                    {countValue}
                </span>
                <span className="title">
                    {countTitle}
                    {showArrow && 
                    <Arrowleft myStyle="arrow"/>
                    }
                </span>
            </div>
        </div>
    )
}

export default TotalCardMini;